'use client';

import React from 'react';

import { Bag } from '@depop/web-thrift-ui/Icons/Bag';
import { useTranslations } from 'next-intl';

import { NudgePill, type NudgePillProps } from '@/components/NudgePill';
import { MAX_COUNT } from '@/modules/nudges/constants';
import { getComputedNudgesCount } from '@/modules/nudges/helpers/getComputedNudgesCount';

type Props = Pick<NudgePillProps, 'className'> & {
  count?: number;
};

export function InBagsNudge({ className, count }: Props) {
  const t = useTranslations('bag');

  if (!count) {
    return null;
  }

  const isGreaterThanMaxCount = count > MAX_COUNT;

  function nudgePillText(count: number) {
    if (isGreaterThanMaxCount) {
      return t('BagNudge.Max');
    }
    return t('BagNudge.Plural', { count: getComputedNudgesCount(count) });
  }

  return (
    <NudgePill
      testId="inBagsNudgeWrapper"
      className={className}
      icon={<Bag size="md" />}
      text={nudgePillText(count)}
    />
  );
}
